import { Flex } from "@chakra-ui/react";
import ContentItem from "./ContentItem";
import { ContaItemResponse } from "core/features/conta/typings";
import moment from "moment";
import { Row, Col } from "antd";
import { OperacaoEnum } from "resources/enums/conta";

interface DescricaoContaProps {
  item: ContaItemResponse;
  operacao?: OperacaoEnum;
}

export default function DescricaoConta({
  item,
  operacao,
}: DescricaoContaProps) {
  return (
    <>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Vencimento"
            descricao={
              item.dataVencimento
                ? moment(item.dataVencimento).format("DD/MM/YYYY")
                : "-"
            }
          />
        </Flex>
        {item.unidade ? (
          <Flex as={Col} xs={6} flexDirection="column">
            <ContentItem
              titulo="Unidade"
              descricao={item.unidade ? item.unidade : "-"}
            />
          </Flex>
        ) : null}
        <Flex
          as={Col}
          xs={OperacaoEnum.Despesa && item.pessoaPagador ? 6 : 12}
          flexDirection="column"
        >
          <ContentItem
            titulo={operacao === OperacaoEnum.Despesa ? "Recebedor" : "Devedor"}
            descricao={item.pessoa ? item.pessoa : "-"}
          />
        </Flex>
        {operacao === OperacaoEnum.Despesa && item.pessoaPagador ? (
          <Flex
            as={Col}
            xs={OperacaoEnum.Despesa && item.pessoaPagador ? 6 : 12}
            flexDirection="column"
          >
            <ContentItem
              titulo={"Pagante"}
              descricao={item.pessoaPagador ? item.pessoaPagador : "-"}
            />
          </Flex>
        ) : null}
      </Flex>
      <Flex py="4px" as={Row} gutter={8}>
        <Flex as={Col} xs={6} flexDirection="column">
          <ContentItem
            titulo="Pago em"
            descricao={
              item.dataPagamento
                ? moment(item.dataPagamento).format("DD/MM/YYYY")
                : "-"
            }
          />
        </Flex>
        {item.dataMovimentacao && operacao === OperacaoEnum.Receita ? (
          <Flex as={Col} xs={6} flexDirection="column">
            <ContentItem
              titulo="Crédito na conta em"
              descricao={moment(item.dataMovimentacao).format("DD/MM/YYYY")}
            />
          </Flex>
        ) : null}
        <Flex as={Col} xs={12} flexDirection="column">
          <ContentItem
            titulo="Resumo"
            descricao={item.descricao ? item.descricao : "-"}
          />
        </Flex>
      </Flex>
    </>
  );
}
